// import React from "react";
// import { useParams } from "react-router-dom";
// import { getFileIcon, truncateFileName } from "../../common/Constants";
// import { Loader } from "../../common/Loader";
// import ChatResponseFormat from "./ChatResponseFormat";
// import { useChatDetails } from "../../api/api-hooks";
// import { formatDateAndTime } from "../../utils/date-utils";

// const ViewChat: React.FC = () => {
//   const { chatId } = useParams<{ chatId: string }>();

//   // Using React Query's useChatDetails hook
//   const {
//     data: chatDetails,
//     error,
//     isLoading,
//   } = useChatDetails(chatId as string);

//   const dateAndTime = formatDateAndTime(chatDetails?.timestamp);

//   if (isLoading) {
//     return <Loader />;
//   }

//   if (error) {
//     return <div>Error loading chat details: {error.message}</div>;
//   }

//   return (
//     <div className="flex flex-col w-full mx-auto h-[100svh] md:h-screen overflow-hidden bg-overallbg px-4">
//       {chatDetails ? (
//         <div className="w-full text-center flex items-center h-fit justify-center relative py-4 pb-2 md:pb-4 border-b">
//           <div className="max-w-[800px] flex-col flex md:flex-row items-center">
//             <div>
//               <h2 className="text-primary m-0 text-[18px] leading-[25px] font-medium">
//                 {chatDetails.chatListName}
//               </h2>
//             </div>
//             <div className="top text-[10px] md:text-[12px] leading-[14px] text-[#1E1E1E] font-light relative md:absolute left-0">
//               {chatDetails.username}&nbsp;&nbsp;
//               <span className="h-full border-[0.5px] border-l-[#1E1E1E]" />
//               &nbsp;&nbsp;{dateAndTime?.date}
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="w-full flex justify-center">
//           <img
//             src="/images/logo.gif"
//             alt="logo"
//             className="my-4"
//             style={{ width: "36px", height: "36px" }}
//           />
//         </div>
//       )}
//       <div className="chat-area max-w-[800px] mx-auto py-4">
//         {chatId &&
//           chatDetails?.prompts.map((prompt, index) => (
//             <div
//               key={prompt.id || index}
//               id={`message-${prompt.prompt_message_id}`}
//               className="flex flex-col relative bottom-0"
//             >
//               <div className="w-full relative">
//                 <div className="flex flex-col items-start justify-center gap-3 rounded-normal rounded-br-none w-fit max-w-[100%] overflow-hidden bg-white md:bg-chatbg p-4 relative float-right mb-3 mx-4 px-6">
//                   {prompt.filename?.map((file, fileIndex) => (
//                     <div
//                       key={fileIndex}
//                       className="relative flex p-4 pr-8 rounded-small border-[1.5px] border-border bg-primarybg"
//                     >
//                       {file.contenttype === "image/png" ? (
//                         <img
//                           src={file.fileurl}
//                           alt={`preview ${fileIndex}`}
//                           className="w-32 h-auto rounded"
//                         />
//                       ) : (
//                         <a
//                           href={file.fileurl}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="text-[16px] font-semibold text-primary leading-[19.09px] flex gap-2 items-center"
//                         >
//                           <img
//                             src={getFileIcon(prompt.filename?.[fileIndex])}
//                             alt="file"
//                           />
//                           {truncateFileName(prompt.filename?.[fileIndex])}
//                         </a>
//                       )}
//                     </div>
//                   ))}

//                   <div className="w-full flex flex-col gap-2 justify-between items-start">
//                     {prompt.kpis && (
//                       <div className="bg-[#E78E24] text-[#fff] flex items-center w-fit text-left p-2 px-4 rounded-[19px] border border-[#D9D9D0]">
//                         <div className="mr-2">
//                           <img
//                             className="w-[14px]"
//                             src="/icons/fi_sun_light.svg"
//                             alt="kpi"
//                           />
//                         </div>
//                         <div className="text-sm leading-[19px] font-normal">
//                           {prompt.kpis}
//                         </div>
//                       </div>
//                     )}
//                     <div className="leading-[21.82px] text-[18px] font-normal text-black">
//                       <div>{prompt.prompt}</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <ChatMessageResponse
//                 messages={chatDetails?.messages.find(
//                   (msg) => msg.prompt_message_id === prompt.prompt_message_id
//                 )}
//               />
//             </div>
//           ))}
//       </div>
//     </div>
//   );
// };

// export default ViewChat;

// interface Message {
//   prompt_message_id: string;
//   generatedText: any;
// }

// interface ChatMessageResponseProps {
//   messages?: Message;
// }

// const ChatMessageResponse: React.FC<ChatMessageResponseProps> = ({
//   messages,
// }) => {
//   return (
//     <div className=" max-w-[100%] rounded-normal rounded-bl-none bg-white md:bg-chatbg px-6 py-5 flex flex-col gap-3 mb-1 mx-4 ">
//       <div className="text-black text-lg flex gap-2">
//         <img src="/icons/Response.svg" alt="logo" className="w-[18px]" />
//         Response
//       </div>
//       <div className="text-[15px] text-secondary font-normal leading-[22px]">
//         <ChatResponseFormat generatedText={messages?.generatedText} />
//         <div className="flex justify-end"></div>
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../../common/Loader";
import LlmResponseFormat from "./LlmResponseFormat";
import { formatDateAndTime } from "../../utils/date-utils";
import { getFileIcon, truncateFileName } from "../../common/Constants";
import { useChatDetails } from "../../api/api-hooks";
// import ProfileCard from "./ProfileCard";

interface Prompt {
  prompt: string;
  context: string | null;
  template: string;
  agent: string;
  llm: string;
  useDatabase: boolean | null;
  database: string | null;
  useOpenAi: boolean | null;
  searchGoogle: string;
  filename: string | null;
  okrs: any;
  kpis: any;
  description: string;
  Function: string;
  Role: string;
  id: string;
  chat_id: string;
  timestamp: string;
  prompt_message_id: string;
  fileurls: string[] | null;
  edited_prompts: any;
}

interface Message {
  id: string;
  chat_id: string;
  generatedText: string;
  prompt_message_id: string;
  isRegenerated: boolean;
  regenerated_responses: any;
}

interface Suggestion {
  id: string;
  chat_id: string;
  suggestion_text: string;
  prompt_message_id: string;
  isRegenerated: boolean;
  regenerated_responses: any;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface ChatDetails {
  chatListName: string;
  prompts: Prompt[];
  id: string;
  timestamp: string;
  last_modified: string;
  messages: Message[];
  suggestions: Suggestion[];
  username: string;
}

interface ChatMessage {
  prompt_message_id: string;
  generatedText?: string;
}

const ViewChat = () => {
  const { chatId } = useParams<{
    chatId: string;
  }>();

  const { data: chatDetails } = useChatDetails(chatId as string);

  const extractKpi = chatDetails?.prompts
    .map((prompt) => prompt.kpis?.trim())
    .filter((kpi) => kpi);

  const dateAndTime = formatDateAndTime(chatDetails?.timestamp);

  const [expanded, setExpanded] = useState(false);

  // const isLong =
  //   displayedPrompt?.split("\n").length > 3 || displayedPrompt?.length > 100;

  const [isLong, setIsLong] = useState(false);

  const promptRef = useRef<HTMLParagraphElement | null>(null);

  useEffect(() => {
    if (promptRef.current) {
      const lineHeight = parseFloat(
        getComputedStyle(promptRef.current).lineHeight || "20"
      );
      const maxLines = 3;
      const maxHeight = lineHeight * maxLines;

      if (promptRef.current.scrollHeight > maxHeight) {
        setIsLong(true);
      } else {
        setIsLong(false);
      }
    }
  }, []);

  return (
    <div className="flex flex-col w-[100%] mx-auto h-[100svh] md:h-screen">
      {chatDetails ? (
        <div className="w-full text-center bg-white flex items-center h-fit justify-center py-4 pb-2 md:pb-4 border-b fixed z-10">
          <div className=" w-full max-w-[700px] mx-auto flex-col flex lg:flex-row items-center justify-center">
            <div className="px-4 md:pl-0">
              <h2 className="text-primary m-0 text-[18px] leading-[25px] font-medium line-clamp-1">
                {extractKpi && extractKpi.length > 0
                  ? `RolesGPT as ${extractKpi.join(", ")}`
                  : chatDetails?.chatListName}
              </h2>
            </div>
            <div className="text-[10px] md:text-[12px] leading-[14px] text-[#1E1E1E] font-light relative lg:absolute left-0 px-4">
              {chatDetails.username}&nbsp;&nbsp;
              <span className="h-full border-[0.5px] border-l-[#1E1E1E]" />
              &nbsp;&nbsp;{dateAndTime.date}
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full flex justify-center">
          <img
            src="/images/logo.gif"
            //src="/icons/tazz/tazz-logo.gif"
            alt="logo"
            className=" my-4"
            style={{ width: "36px", height: "36px" }}
          ></img>
        </div>
      )}
      <div className="flex flex-col justify-between h-full w-full px-4">
        <div className=" h-[calc(100%-110px)] pt-14">
          <div
            className={`h-full overflow-auto ${
              chatDetails ? "" : "scrollbar-hidden"
            }`}
          >
            <div className="w-full max-w-[800px] mx-auto py-4">
              {chatDetails === null ? (
                <Loader />
              ) : (
                chatId &&
                chatDetails?.prompts.map((prompt: any, index: any) => {
                  if (!prompt || !prompt.prompt) return null;

                  return (
                    <div
                      key={prompt.id || index}
                      id={`message-${prompt.prompt_message_id}`}
                      className="flex flex-col items-end relative bottom-0"
                    >
                      {prompt.filename && (
                        <div className="w-full relative">
                          <div className="flex flex-col items-start justify-center gap-3 rounded-normal rounded-br-none w-fit max-w-[100%] overflow-hidden bg-white md:bg-chatbg p-4 relative float-right mb-3 mx-4 px-6">
                            {Array.isArray(prompt.filename) &&
                              prompt.filename.map(
                                (file: any, fileIndex: any) => (
                                  <div
                                    key={fileIndex}
                                    className="relative flex p-4 pr-8 rounded-small border-[1.5px] border-border bg-primarybg"
                                  >
                                    {file?.contenttype === "image/png" ? (
                                      <img
                                        src={file?.fileurl}
                                        alt={`preview ${fileIndex}`}
                                        className="w-32 h-auto rounded"
                                      />
                                    ) : (
                                      <a
                                        href={file?.fileurl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-[16px] font-semibold text-primary leading-[19.09px] flex gap-2 items-center"
                                      >
                                        <img
                                          src={getFileIcon(file)}
                                          alt="file"
                                        />
                                        {truncateFileName(file)}
                                      </a>
                                    )}
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      )}
                      {/* <ProfileCard prompt={prompt} username={chatDetails.username} isShared /> */}
                      {/* Prompt */}
                      <div
                        className={`flex items-start mx-0 md:mx-0 mt-2 px-4 ${
                          isLong ? "pr-2" : ""
                        }  py-2 font-light bg-[#EAEEF5] rounded-[20px] w-fit max-w-[90%] whitespace-pre-wrap`}
                      >
                        {/* <p>{template ? template : prompt}</p> */}
                        <p
                          ref={promptRef}
                          className={`whitespace-pre-wrap transition-all duration-300 ${
                            !expanded ? "line-clamp-3" : ""
                          }`}
                        >
                          {prompt.prompt}
                        </p>

                        {isLong && (
                          <button
                            className="p-1 px-2 text-sm text-primary_1 rounded-full hover:bg-gem_hover flex items-center gap-1 shrink-0"
                            onClick={() => setExpanded((prev) => !prev)}
                          >
                            <div className={expanded ? "rotate-180" : ""}>
                              <i
                                className={`icon2-chevron-down text-[0.625em]`}
                              />
                            </div>
                          </button>
                        )}
                      </div>
                      <ChatMessageResponse
                        messages={chatDetails?.messages?.find(
                          (msg) =>
                            msg.prompt_message_id === prompt.prompt_message_id
                        )}
                        agent={prompt?.agent}
                      />
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewChat;

interface ChatMessageResponseProps {
  messages?: ChatMessage;
  agent?: string;
}

function ChatMessageResponse({ messages, agent }: ChatMessageResponseProps) {
  return (
    <div className="max-w-[100%] rounded-normal rounded-bl-none bg-white md:bg-chatbg py-4 flex flex-col gap-0">
      <div className=" text-black text-lg flex gap-2">
        <img src="/icons/logo.svg" alt="logo" className="w-[18px]"></img>
        {agent ? agent.replace(/_/g, " ") : "Response"}
      </div>
      <div className="text-[14px] md:text-[16px] text-secondary font-normal leading-[22px]">
        <div className="mt-0 text-content">
          <LlmResponseFormat
            generatedText={messages?.generatedText || ""}
            llm={""}
            okrs={""}
          />
        </div>
        <div className="flex justify-end"></div>
      </div>
    </div>
  );
}
